import {
  GuidIdCodeAndLabel, BrandAndMarketListItem, SearchRuleOrderValue, CodeAndLabel,
} from '../../../integrated-client';
import {DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem
  carrier?: GuidIdCodeAndLabel
  description?: string
  fareType?: CodeAndLabel
  showDeleted?: boolean
  showDisabled?: boolean
  orderByDescending?: boolean;
  orderValue?: SearchRuleOrderValue;
  offset: number
  limit: number
  total: number
  currentPage: number
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem
  carrier?: GuidIdCodeAndLabel
  description?: string
  fareType?: CodeAndLabel
  showDeleted?: boolean
  showDisabled?: boolean
  orderByDescending?: boolean
  orderValue?: SearchRuleOrderValue
  offset: number
  limit: number
  total: number
  currentPage: number

  constructor() {
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS
    this.currentPage =  1
  }

}
